<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {},
  mounted() {},
};
</script>

<style>
body,
html {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 16px;
  font-family: "Noto Serif", "Microsoft JhengHei", "Microsoft YaHei", 新細明體,
    "Helvetica Neue", Helvetica, Arial, sans-serif;
}
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.container {
  padding: 5px 14px;
  height: 100%;
  width: calc(100% - 28px);
  max-width: 1100px;
  margin: 0 auto;
}
</style>
